import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2, LockKeyhole } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { useBranding } from "@/context/BrandingContext";
import { BrandMark } from "@/components/portal/PortalShell";
import { formatApiError } from "@/lib/api";

export default function LoginPage() {
  const { user, login } = useAuth();
  const { config } = useBranding();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-bg flex min-h-screen items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm rounded-md border border-white/10 bg-[#141C2E] p-8 shadow-2xl" data-testid="admin-login-form">
        <div className="mb-8 flex items-center gap-3">
          <BrandMark config={config} size="sm" />
          <div>
            <p className="font-display text-sm text-slate-100">{config?.org_name}</p>
            <p className="text-xs text-slate-500">Painel do operador</p>
          </div>
        </div>
        <h1 className="flex items-center gap-2 text-xl font-semibold text-slate-50"><LockKeyhole className="h-5 w-5" style={{ color: "var(--brand)" }} /> Acesso restrito</h1>
        <div className="mt-6 space-y-4">
          <Input type="text" autoCapitalize="none" autoComplete="username" placeholder="Usuário" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 border-white/10 bg-black/30 text-slate-100" data-testid="admin-login-username" required />
          <Input type="password" autoComplete="current-password" placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 border-white/10 bg-black/30 text-slate-100" data-testid="admin-login-password" required />
        </div>
        {error && <p className="mt-3 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-gold mt-6 h-11 w-full" data-testid="admin-login-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Entrar"}
        </button>
      </form>
    </div>
  );
}
